import styled from '@emotion/styled'
import { colors, radius } from '@mobi/component-library/Foundations'

export const IconWrapperStyled = styled.span({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: radius.lg,
  filter:
    'drop-shadow(0px 1px 1.5px rgba(26, 14, 35, 0.08)) drop-shadow(0px 1px 3px rgba(26, 14, 35, 0.12))',
  overflow: 'hidden',
  border: '0.2rem solid ' + colors.white,
  background: colors.white,

  ':empty': { display: 'none' },

  '> img': { width: '100%', height: 'auto' },
})
